import React from 'react';
import { useTranslation } from 'react-i18next';

import { StyledGate } from './index.styles';
import { getLifecycleGroupLabel } from 'src/Lca/LCADiagram/labels';

export default function Gate() {
  const { t } = useTranslation('lca');
  const gateLabel = getLifecycleGroupLabel(t, 'gate', 'GATE').toUpperCase();

  return (
    <StyledGate>
      <div style={{ position: 'absolute', top: -30, left: -20 }}>
        {gateLabel}
      </div>
    </StyledGate>
  );
}
